// src/pages/BlogList.tsx
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAllPosts } from '../blog/blogSlice';
import { useTranslation } from 'react-i18next';

const BlogList: React.FC = () => {
  const posts = useSelector(selectAllPosts);
  const { t, i18n } = useTranslation();
  const lang = i18n.language || 'cs';

  return (
    <Container style={{ paddingTop: 96, paddingBottom: 24 }}>
      <Row className="mb-4">
        <Col>
          <h2>{t('blog.list.title')}</h2>
          <p className="text-muted">{t('blog.list.subtitle')}</p>
        </Col>
      </Row>
      <Row className="g-3">
        {posts.map((post: any) => {
          const tr = post.translations?.[lang] || post.translations?.cs || Object.values(post.translations || {})[0];
          return (
            <Col key={post.id} xs={12} md={6} lg={4} className="d-flex">
              <Card
                as={Link as any}
                to={`/blog/${post.id}`}
                className="blog-card text-reset text-decoration-none h-100 w-100"
              >
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="blog-title">{tr?.title}</Card.Title>
                  <Card.Subtitle className="mb-2 text-muted">
                    {new Date(post.date).toLocaleDateString()}
                  </Card.Subtitle>
                  <Card.Text className="blog-excerpt">{tr?.excerpt}</Card.Text>
                  <Card.Text className="mt-auto fw-semibold">{t('blog.list.readMore')}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </Container>
  );
};

export default BlogList;
